import { useCallback, useRef, useState } from 'react';

export const useTimeout = (
  ms: number,
): { state: boolean; destroy: () => void; startTimeout: () => void; endTimeout: () => void } => {
  const [state, setState] = useState(false);
  const timeRef = useRef<NodeJS.Timeout>();

  const startTimeout = useCallback(() => {
    if (!timeRef.current) {
      setState(false);

      timeRef.current = setTimeout(() => {
        setState(true);
      }, ms);
    }
  }, []);

  const endTimeout = useCallback(() => {
    if (timeRef.current) {
      clearTimeout(timeRef.current);
    }
    timeRef.current = undefined;
  }, []);

  const destroy = useCallback(() => {
    setState(false);
    endTimeout();
  }, []);

  return {
    state,
    destroy,
    startTimeout,
    endTimeout,
  };
};
